import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';

import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { toDate } from 'helpers/Formatter';

import MenuHeader from 'components/shared/MenuHeader';
import DatePicker from 'material-ui/DatePicker';
import { CSVLink } from 'react-csv';

import Collapsible from 'react-collapsible';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import { toFriendlyDateString, toFriendlyDateTimeString } from 'helpers/Formatter';

export default (class AccountingOverview extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      dateRangePicker: {
        range1: {
          startDate: new Date(),
          endDate: null,
        },
      },
      columnDisplay: 0,
      accrual: true,
      compare: false,
      option1Open: false,
      properties: [],
      users: [],
      allAgentsAndMaintenance: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.reportType === 'maintenance_work_log') return;
    const startDate = toDate(nextProps.dateRange.start_date) || new Date();
    const endDate = toDate(nextProps.dateRange.end_date);
    this.setState({
      dateRangePicker: {
        range1: {
          startDate,
          endDate,
        },
      },
    });
  }

  // TODO: <DateRangePicker /> from react-date-range seems to update itself multiple times on its own, and hence it is causing a render stack overflow.
  // Below is a hack to have <DateRangePicker /> render in a new render stack
  // Replace this with the new custom Date Picker component later
  HACK_renderStackResetted = false;
  componentDidMount() {
    if (this.props.reportType === 'maintenance_work_log') {
      const startDate = new Date();
      const endDate = new Date();
      this.setState({
        dateRangePicker: {
          range1: {
            startDate,
            endDate,
          },
        },
      });
    }
    setTimeout(() => {
      this.HACK_renderStackResetted = true;
    }, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allAgentsAndMaintenance !== this.props.allAgentsAndMaintenance) {
      this.setState({
        allAgentsAndMaintenance: this.props.allAgentsAndMaintenance,
      });
    }
  }

  handleRangeChange(which, payload) {
    this.setState({
      [which]: {
        ...this.state[which],
        ...payload,
      },
    });
  }

  createReport = () => {
    this.props.generateReport(
      this.state.isAccrual,
      this.state.dateRangePicker.range1,
      this.state.properties,
      this.state.transactions,
      this.props.reportType,
      {},
      this.state.users
    );
  };

  handleSelect = properties => {
    if (properties) {
      const property_ids = properties.map((property, index) => property.value);
      this.setState({ properties: property_ids });
      if (this.props.reportType === 'maintenance_work_log') {
        this.setState({
          users: [],
          allAgentsAndMaintenance: [],
        });
        this.props.getAllAgentsAndMaintenanceForProperties(property_ids);
      }
    }
  };

  convertValue = objectToFormat => {
    if (objectToFormat.isDate) {
      return toFriendlyDateString(objectToFormat.value);
    }
    if (objectToFormat.isDateTime) {
      return toFriendlyDateTimeString(objectToFormat.value);
    }

    return objectToFormat.value;
  };

  reportDataCSV = reportData => {
    return reportData.map(outerArray =>
      outerArray.map(innerArray => this.convertValue(innerArray))
    );
  };

  render() {
    const customizationHeader = this.state.option1Open ? 'Click to Close' : 'Click to Customize';
    const reportTypes = [
      'aged_receivables',
      'aged_payables',
      'vacancy_report',
      'rent_roll',
      'deposits_report',
      'ancillary_items',
      'resident_data_report',
      'prospect_data_report',
      'lead_marketing_report',
      'detailed_resident_data_report',
    ];

    const showDatePickerOnly = reportTypes.includes(this.props.reportType);
    const properties = this.props.properties;

    const style = {
      receipt_header: {
        margin: '5px -5px 10px',
        backgroundColor: colors.LIGHT_GRAY,
        padding: '5px 0px',
        fontSize: '14px',
        fontWeight: '800',
      },
    };

    const asOfPickerType = reportTypes.includes(this.props.reportType);
    const showAgentAndMaintenancesOfProperties = this.props.reportType === 'maintenance_work_log';
    return (
      <Collapsible
        trigger={
          <MenuHeader
            menuTitle={customizationHeader}
            isOpen={this.state.option1Open}
            paddingMargin="0 10px 5px"
            backgroundColor={colors.WHITE}
            style={{ textAlign: 'center' }}
            float="initial"
            color={colors.BLUE}
          />
        }
        onOpening={() => this.setState({ option1Open: true })}
        onClosing={() => this.setState({ option1Open: false })}
        open={false}
        transitionTime={200}
      >
        {
          <div className="row">
            <div className="col-sm-8" style={{ marginBottom: '15px' }}>
              {!asOfPickerType &&
                this.HACK_renderStackResetted && (
                  <div>
                    <div className="row" style={style.receipt_header}>
                      <div className="col-xs-12" style={{ padding: 0 }}>
                        <p style={{ margin: '0', textAlign: 'center' }}> Date Range </p>
                      </div>
                    </div>
                    <div className="row" style={{ textAlign: 'center' }}>
                      <DateRangePicker
                        showMonthAndYearPickers={false}
                        showMonthArrow={false}
                        ranges={[this.state.dateRangePicker.range1]}
                        onChange={this.handleRangeChange.bind(this, 'dateRangePicker')}
                        scroll={{ enabled: true }}
                        theme={{
                          DayInRange: {
                            background: colors.LIGHT_GRAY,
                          },
                          DayHover: {
                            background: colors.WHITE,
                            color: AccentColor(),
                            transform: 'scale(1.1) translateY(-10%)',
                          },
                          DayActive: {
                            background: colors.LIGHT_GRAY,
                            boxShadow: 'none',
                          },
                        }}
                      />
                    </div>
                  </div>
                )}
            </div>

            <div className="col-sm-4" style={{ marginBottom: '15px' }}>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12" style={{ padding: 0 }}>
                  <p style={{ margin: '0', textAlign: 'center' }}> Table Options </p>
                </div>
              </div>

              <div className="row">
                <h5>Select properties</h5>
                <MultiSelectExtended
                  multiple
                  onChange={this.handleSelect}
                  name="property_select"
                  hintText="Property"
                  data={properties}
                  innerDivStyle={{
                    width: '100%',
                    fontSize: '15px',
                    fontWeight: '100 !important',
                  }}
                  menuStyle={{ minWidth: '250px', fontSize: '15px' }}
                  style={{ fontSize: '15px' }}
                  fullWidth
                />
              </div>
              {showAgentAndMaintenancesOfProperties &&
                this.state.allAgentsAndMaintenance.length > 0 && (
                  <div className="row" style={{ marginTop: '20px' }}>
                    <h5>Select users</h5>
                    <MultiSelectExtended
                      multiple
                      onChange={values => {
                        this.setState({ users: values });
                      }}
                      name="users_select"
                      hintText="Users"
                      data={this.state.allAgentsAndMaintenance}
                      innerDivStyle={{
                        width: '100%',
                        fontSize: '15px',
                        fontWeight: '100 !important',
                      }}
                      menuStyle={{ minWidth: '250px', fontSize: '15px' }}
                      style={{ fontSize: '15px' }}
                      fullWidth
                      grouped
                    />
                  </div>
                )}
              {showDatePickerOnly && (
                <div className="row">
                  <DatePicker
                    floatingLabelText="As Of Date"
                    textFieldStyle={{ fontSize: '14px' }}
                    style={{ marginTop: '-7px' }}
                    onChange={(e, date) =>
                      this.setState({ dateRangePicker: { range1: { startDate: date } } })}
                  />
                </div>
              )}
              <div className="row" style={{ marginTop: '15px' }}>
                <CSVLink
                  filename={`yuhu_generated_${this.props.reportType}_report.csv`}
                  data={this.reportDataCSV(this.props.reportData)}
                >
                  Click here to download CSV file
                </CSVLink>
              </div>

              <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
                <FlatButton
                  label="Run"
                  type="button"
                  id="button"
                  backgroundColor={AccentColor()}
                  hoverColor="grey"
                  onClick={this.createReport}
                  style={{ color: colors.WHITE }}
                />
              </div>
            </div>
          </div>
        }
      </Collapsible>
    );
  }
});
